import { default as classnames } from 'classnames';
import _ from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { ButtonWithTooltip } from '../../../../../components/Basic/Buttons';
import { Link } from '../../../../../components/Basic/Elements';
import { Input } from '../../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../../components/Common/Input/ProviderList';
import CommissionNdsBlock from '../../../../../components/Markets/Blocks/CommissionNdsBlock';
import { numberWithSpaces } from '../../../../../utils';
import styles from './styles.module.scss';

export const GO_TO_WB = (id) => `https://www.wildberries.ru/catalog/${id}/detail.aspx?targetUrl=SP`;


const WIDTH_MARKETPLACE = [
  '110px', //0
  '160px', //1
  '400px', //2
  '100px', //3
  '100px', //4
  '60px', //5
  '150px', //6
  '160px', //7
  '200px', //8
  '150px', //9
  '40px', //10
  '170px', //11
  '120px', //12
  '75px', //13
];

const MarketsLine = ({
  warehouses = [],
  key,
  item = {},
  suppliesNumbers = [],
  isOwner = false,
  onChangeProduct = (_) => _,
  market = '',
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const card = item
  const [isOpenWarehouseArray, setIsOpenWarehouseArray] = useState(false);

  const openImageViewer = (imgs) => {
    setImages(imgs);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  let onChange = (key, value, skladName) => {
    if (card[key] === value) {
      return;
    }
    onChangeProduct(card._id, card.offer_id, key, value, skladName);
  };

  // useEffect(() => {
  //   setCard(item);
  // }, [item, shop]);



  return (
    <>
      <TableLine key={key} isError={card.errors_array?.length > 0}>
        <TableCell center width={WIDTH_MARKETPLACE[13]}>
          <div style={{ color: '#410357af', fontSize: '17px' }}>{card.storage.shop}</div>
        </TableCell>
        <TableCell center width={WIDTH_MARKETPLACE[5]}>
          <div className={styles.wrapper}>
            <img
              onClick={() => openImageViewer(card.images)}
              className={styles.preview}
              src={(card.images || []).length > 0 ? card.images[0] : undefined}
            />
          </div>
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[1]}>
          {card.offer_id}
          <Row style={{ width: '100%' }}>
            <Link
              blue={true}
              href={GO_TO_WB(card.nmID)}
              style={{ width: 'auto', fontSize: '10px', userSelect: 'auto' }}
              target={'_blank'}
            >
              {card.nmID}
            </Link>
          </Row>
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[2]} style={{ flexWrap: 'nowrap' }}>
          <Column>
            <p className={styles.name_text}>{card.name}</p>
            <TextGrey fontSize={12}>{card.category}</TextGrey>
          </Column>
        </TableCell>

        <TableCell width={WIDTH_MARKETPLACE[3]} center
          style={{ cursor: 'pointer' }}
          onClick={() => setIsOpenWarehouseArray(!isOpenWarehouseArray)}
        >
          <ButtonWithTooltip style={{
            fontSize: '22px', 'fontWeight': 600
          }}
            stopPropagation={false}
            tooltip={isOpenWarehouseArray ? 'Скрыть список' : 'Показать список'}
          >
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{card.storage.stock?.warehouse || 0}</span>
          </ButtonWithTooltip>

        </TableCell>
        {/* 
        <TableCell width={WIDTH_MARKETPLACE[3]} center>
          <Column style={{ alignItems: 'center' }} center={true}>
            <Text fontSize={'16px'} center readOnly>{Object.keys(_.groupBy(card.storage?.history, 'date')).length}</Text>
            <TextGrey fontSize={12}>{moment(card.history_storage_wb?.appear_date).format('YYYY-MM-DD')}</TextGrey>
          </Column>
        </TableCell> */}

        <TableCell width={WIDTH_MARKETPLACE[11]} center>
          <Row>
            <Text center><b style={{ fontSize: '18px' }}>{+(card.storage?.total_storage).toFixed(0) || 0}</b> / <span style={{ fontSize: '15px', color: '#000000cc' }}>{+((card.storage?.total_storage || 0) / Object.keys(_.groupBy(card.storage?.history, 'date')).length).toFixed(1) || 0}</span></Text>
          </Row>
          <Row style={{ color: '#000000ad' }} center>{Math.ceil(card.storage?.full_storage)}</Row>
        </TableCell>

        <TableCell width={WIDTH_MARKETPLACE[7]} center>
          <Row>
            <Text style={{ width: '70px' }}>{card.prices?.price}</Text> /{' '}
            <Input value={card?.prices?.old_price} width={'70px'} center onBlur={(v) => onChange('price', v)} />
          </Row>
        </TableCell>

        <TableCell width={WIDTH_MARKETPLACE[4]} center>
          <Input value={card.purchase} center onBlur={(v) => onChange('purchase', v)} />
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[4]} center>
          <Input value={card.discount?.percent} center onBlur={(v) => onChange('discount', v)} />
        </TableCell>

        <TableCell
          width={WIDTH_MARKETPLACE[6]}
          style={{
            flexDirection: 'row',
          }}
          center
        >
          <Text className={classnames(styles.block_mar, card.profit?.is_minus && styles.red_text)}>
            {Number.isFinite(card.profit?.percent) ? Math.ceil(card.profit?.percent) : '-'} %
          </Text>
          <div className={styles.block_commission}>
            <Text fontWeight={600} className={card.profit?.is_minus ? styles.red_text : styles.green_text}>
              {Number.isFinite(card.profit?.percent) ? numberWithSpaces(Math.ceil(card.profit?.rub)) : '-'}
            </Text>
            <CommissionNdsBlock card={card} market={market} />
          </div>
        </TableCell>

        <TableCell width={WIDTH_MARKETPLACE[4]} center>
          <Column style={{ alignItems: 'center' }} center={true}>
            <Text fontWeight={card.sale_statistic?.num_sales > 0 ? 600 : 400}>{card.sale_statistic?.num_sales}</Text>
            {card.sale_statistic?.date_last_sale && (
              <TextGrey style={{ textAlign: 'center', fontSize: '12px' }}>
                {moment(card.sale_statistic?.date_last_sale).fromNow()}
              </TextGrey>
            )}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[11]} center>
          <ProviderList
            selectProviderId={card.provider_id}
            disabled={true}
            onSelect={(v) => onChange('provider_id', v.id)}
          />
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[7]} center>
          <Input value={card.provider_artnumber} onBlur={(v) => onChange('provider_artnumber', v)} />
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[4]} center>
          <Input value={card.quantity} disabled={!isOwner} center onBlur={(v) => onChange('quantity', v)} />
        </TableCell>
        <TableCell width={WIDTH_MARKETPLACE[7]} center>
          <Input value={card.warehouse_id} disabled={!isOwner} onBlur={(v) => onChange('warehouse_id', v)} />
        </TableCell>


        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}


      </TableLine>
      {isOpenWarehouseArray && (
        <Column style={{}} className={styles.history_block}>
          {Object.keys(_.groupBy(card.storage.history, 'warehouse_id')).sort()
            .map(warehouse_id => {
              const history = _.sortBy(card.storage.history.filter(h => h.warehouse_id == warehouse_id), 'date')
              return {
                sklad: warehouses.find(w => w.ID == warehouse_id)?.name,
                ...(card.storage?.stock?.by_warehouses?.find(w => w.warehouse_name === warehouses.find(w => w.ID == warehouse_id)?.name)),
                history,
                warehouse_id,
                supplies: Object.keys(_.groupBy(history, 'sup_id'))?.filter(id => suppliesNumbers.includes(`${id}`)).join(', ')
              }
            })
            .map((sklad, i) => (
              <Column key={sklad.warehouse_id}>

                <Row style={{ minHeight: '30px', width: 'min-content' }} key={sklad.warehouse_name}>
                  <div style={{ textAlign: 'center', color: '#00000078', fontWeight: 'bold', minWidth: '20px' }}>{i + 1}</div>
                  <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Column style={{ minWidth: '240px' }}>
                    <TextGrey style={{ alignContent: 'center', color: '#0000007f' }}>Склад:<span style={{ color: '#000000ff', fontSize: '18px' }}> {sklad.sklad}</span>  </TextGrey>
                  </Column>
                  <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Column style={{ minWidth: '200px' }}>
                    {/* <TextGrey style={{ color: '#0000007f' }}>За все время: <span style={{ fontWeight: 'bold', color: '#000000ff' }}>{Math.ceil(sklad.history?.reduce((acc, s) => { return acc + s.pay }, 0))} руб.</span></TextGrey> */}
                    <TextGrey style={{ color: '#0000007f' }}>Дней хранения:<span style={{ color: '#000000ff', fontSize: '18px' }}> {sklad.history?.length}</span>  </TextGrey>
                    <TextGrey style={{ color: '#0000007f' }}>Сумма хранения: <span style={{ fontWeight: 'bold', color: '#000000ff' }}>{Math.ceil(sklad.history?.reduce((acc, s) => { return acc + s.pay }, 0))} руб.</span></TextGrey>
                    <TextGrey style={{ color: '#0000007f' }}>В день:  <span style={{ color: '#000000ff' }}> {
                      +(
                        sklad.history?.reduce((acc, s) => { return acc + s.pay }, 0) /
                        sklad.history.length
                      ).toFixed(1) || 0} руб.
                    </span></TextGrey>
                  </Column>
                  <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Column style={{ minWidth: '220px' }}>
                    <TextGrey style={{ color: '#0000007f' }}>Средний объем:  <span style={{ color: '#000000ff' }}> {
                      +(
                        sklad.history?.reduce((acc, s) => { return acc + (s.v * s.quantity) }, 0) /
                        sklad.history.length
                      ).toFixed(1) || 0} л
                    </span></TextGrey>
                    <TextGrey style={{ color: '#0000007f' }}>Средний коэффициент:  <span style={{ color: '#000000ff' }}> {
                      +(
                        sklad.history?.reduce((acc, s) => { return acc + s.c }, 0) /
                        sklad.history.length
                      ).toFixed(1) || 0} %
                    </span></TextGrey>
                    <TextGrey style={{ color: '#0000007f' }}>Среднее количество:  <span style={{ color: '#000000ff' }}> {
                      +(
                        sklad.history?.reduce((acc, s) => { return acc + s.quantity }, 0) /
                        sklad.history.length
                      ).toFixed(1) || 0} шт.
                    </span></TextGrey>
                  </Column>
                  <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Column style={{ minWidth: '180px' }}>
                    {sklad.common && (<>
                      <TextGrey style={{ color: '#0000007f' }}>Остаток на складе: <span style={{ color: '#000000ff' }}>{sklad.warehouse} </span></TextGrey>
                      <TextGrey style={{ color: '#0000007f' }}>Общий остаток:  <span style={{ color: '#000000ff' }}> {sklad.common}</span></TextGrey>
                    </>)}
                  </Column>
                  <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Column style={{ minWidth: '180px' }}>
                    {(sklad.common - sklad.warehouse) > 0 && (<>
                      <TextGrey style={{ color: '#0000007f' }}>В пути к клиенту: <span style={{ color: '#000000ff' }}>{sklad.in_way_to_client} </span></TextGrey>
                      <TextGrey style={{ color: '#0000007f' }}>В пути от клиенту:  <span style={{ color: '#000000ff' }}> {sklad.in_way_from_client}</span></TextGrey>
                    </>)}
                  </Column>
                  <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Column style={{ minWidth: '380px' }}>
                    <TextGrey style={{ color: '#0000007f' }}>Последний день хранения: <span style={{ color: '#000000ff' }}>{moment(_.last(sklad.history)?.date).format('DD.MM.YYYY')} </span></TextGrey>
                    {sklad.supplies && (<TextGrey style={{ color: '#0000007f' }}>Связанные поставки: <span style={{ color: '#000000ff' }}>{sklad.supplies} </span></TextGrey>)}
                  </Column>
                </Row>
                <hr style={{ width: '100%', borderColor: '#00000035' }}></hr>
              </Column>
            ))}
        </Column>
      )}

    </>
  );
};

export default MarketsLine;
